import LoadingSpinner from 'components/loading-spinner';
import React, { useEffect } from 'react';
import RunSimpleCalibration from 'views/bluviu-nutrition/features/calibrations/components/edit-calibration/simple/run-simple-calibration';
import SimpleCalibrationActions from 'views/bluviu-nutrition/features/calibrations/components/edit-calibration/simple/simple-calibration-actions';
import SimpleCalibrationFeedProgram from 'views/bluviu-nutrition/features/calibrations/components/edit-calibration/simple/simple-calibration-feed-program';
import SimpleCalibrationInformation from 'views/bluviu-nutrition/features/calibrations/components/edit-calibration/simple/simple-calibration-information';
import SimpleCalibrationProgress from 'views/bluviu-nutrition/features/calibrations/components/edit-calibration/simple/simple-calibration-progress';
import SimpleCalibrationStatistics from 'views/bluviu-nutrition/features/calibrations/components/edit-calibration/simple/simple-calibration-statistics';
import { CalibrationState } from 'views/bluviu-nutrition/features/calibrations/types/calibration-state.enum';
import { useCalibrationState } from '../../context/calibration-context';
import SimpleCalibrationInputs from './simple/simple-calibration-inputs';
import TemperatureLocation from './temperature-location';
import Paper from 'components/paper';
import { Box } from '@mui/material';

const EditSimpleCalibration = () => {
  const {
    simpleCalibrationQuery: { data: calibration, isLoading },
    simpleCalibrationStatusQuery: { refetch },
  } = useCalibrationState();

  useEffect(() => {
    if (calibration?.state === CalibrationState.SUBMITTED) {
      refetch();
    }
  }, [calibration]);

  if (isLoading) return <LoadingSpinner />;

  return (
    <Box display={'flex'} flexDirection={'column'} gap={4}>
      <SimpleCalibrationProgress />
      <SimpleCalibrationStatistics />
      <Paper transparent>
        <Box display={'flex'} flexDirection={'column'} gap={4}>
          <SimpleCalibrationActions />
          <SimpleCalibrationInformation />
          <TemperatureLocation />
          <SimpleCalibrationInputs />
          <SimpleCalibrationFeedProgram />
          <RunSimpleCalibration />
        </Box>
      </Paper>
    </Box>
  );
};

export default React.memo(EditSimpleCalibration);
